import { GroupBase, OptionsOrGroups } from 'react-select'
import { SelectOption } from '.'

export type Options = OptionsOrGroups<
  SelectOption<string>,
  GroupBase<SelectOption<string>>
>

export const sortOptions = (optionsOrGroups: Options) => {
  return optionsOrGroups
    .map((option) => {
      if ('options' in option) {
        // It's a group, sort the options within the group
        return {
          ...option,
          options: [...option.options].sort(
            (a: SelectOption<string>, b: SelectOption<string>) =>
              a.label.localeCompare(b.label)
          ),
        }
      }
      // It's a regular option, return as is
      return option
    })
    .sort((a, b) => {
      // Sort groups by their label, and regular options by their label
      const aLabel = 'label' in a ? a.label : a.options?.[0]?.label || ''
      const bLabel = 'label' in b ? b.label : b.options?.[0]?.label || ''
      return (aLabel ?? '').localeCompare(bLabel ?? '')
    })
}

export const getFirstItemOfOptions = (optionsOrGroups: Options) => {
  const firstOption = optionsOrGroups[0]
  if (firstOption && 'options' in firstOption) {
    // It's a group, get the first option from the group
    return firstOption.options[0]
  }
  // It's a regular option
  return firstOption as SelectOption<string>
}
